import { Template } from "@/lib/types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type InspectorStateName = "projectSettings" | "text" | "media-library" | "image" | "group" | "shapes";

type TemplateEditorSliceState = {
  currentInspectorState: InspectorStateName;
  currentTemplate: Template | null;
  templateHasChanges: boolean;
};

const initialState: TemplateEditorSliceState = {
  currentInspectorState: "projectSettings",
  currentTemplate: null,
  templateHasChanges: false,
};

const templateEditorSlice = createSlice({
  name: "templateEditorSlice",
  initialState,
  reducers: {
    resetCurrentInspectorState(state) {
      state.currentInspectorState = "projectSettings";
    },
    setCurrentInspectorState(state, { payload }: PayloadAction<InspectorStateName>) {
      state.currentInspectorState = payload;
    },
    setCurrentTemplate(state, { payload }: PayloadAction<Template | null>) {
      state.currentTemplate = payload;
      state.templateHasChanges = false;
    },
    setCurrentCanvasData(state, { payload }: PayloadAction<Template["canvas_data"]>) {
      state.currentTemplate!.canvas_data = payload;
      state.templateHasChanges = true;
    },
    setCurrentTemplateName(state, { payload }: PayloadAction<Template["name"]>) {
      state.currentTemplate!.name = payload;
    },
    setTemplateHasChanges(state, { payload }: PayloadAction<boolean>) {
      state.templateHasChanges = payload;
    },
  },
});

const templateEditorReducer = templateEditorSlice.reducer;

const {
  setCurrentInspectorState,
  resetCurrentInspectorState,
  setCurrentTemplate,
  setCurrentCanvasData,
  setCurrentTemplateName,
  setTemplateHasChanges,
} = templateEditorSlice.actions;

export {
  templateEditorReducer,
  setCurrentInspectorState,
  resetCurrentInspectorState,
  setCurrentTemplate,
  setCurrentCanvasData,
  setCurrentTemplateName,
  setTemplateHasChanges,
};
